import { CATEGORIES, CATEGORY_CODES, type TransactionCategory } from '@debtbot/shared';
import { useLocale } from '../i18n';
import { haptic } from '../telegram/haptic';

export function CategoryChips({
  value,
  onChange,
}: {
  value: TransactionCategory | null;
  onChange: (v: TransactionCategory | null) => void;
}) {
  const locale = useLocale();
  return (
    <div className="flex flex-wrap gap-2">
      {CATEGORY_CODES.map((code) => {
        const active = value === code;
        return (
          <button
            key={code}
            type="button"
            aria-pressed={active}
            data-testid={`category-${code}`}
            onClick={() => {
              haptic.select();
              onChange(active ? null : code);
            }}
            className={`rounded-full px-3 py-2 text-sm ${active ? 'bg-button text-button-text' : 'bg-secondary-bg'}`}
          >
            {CATEGORIES[code].emoji} {CATEGORIES[code].label[locale]}
          </button>
        );
      })}
    </div>
  );
}
